import { combineReducers } from 'redux';
import adminReducer from './auth/reducer';

const rootReducer = combineReducers({
  adminReducer: adminReducer,
});

export default rootReducer;
